import { legacyTabToPath } from "@/lib/portal-nav";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/government/dashboard")({
  validateSearch: (search: Record<string, unknown>) => ({
    licenseId: (search.licenseId as string) || undefined,
    tab: (search.tab as string) || undefined,
  }),
  beforeLoad: ({ search }) => {
    const to = legacyTabToPath("government", search.tab as string | undefined);
    const nextSearch: Record<string, unknown> = {};
    if (to.includes("/registrations") && search.licenseId) {
      nextSearch.licenseId = search.licenseId;
    }
    throw redirect({ to, search: nextSearch, replace: true });
  },
  component: () => null,
});
